import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Box, Input } from 'wt-ui';
import { FormDown } from 'grommet-icons';

// import DateDrop from './DateDrop';
import CustomDateDrop from './CustomDateDrop';

const Dates = ({ startDate, endDate, disabled }) => {
  // console.log('Dates: ', data);
  const format = dateStr => {
    const d = new Date(dateStr);
    return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
  };
  return (
    <Input
      disabled={disabled}
      style={{ minWidth: '337px', textAlign: 'center', cursor: 'pointer' }}
      placeholder="Select date range..."
      value={
        startDate && endDate
          ? `From: ${format(startDate)} - To: ${format(endDate)}`
          : ''
      }
    />
  );
};
Dates.defaultProps = {
  disabled: false,
};
Dates.propTypes = {
  disabled: PropTypes.bool,
  endDate: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
};

const DatePicker = ({ dispatch, startDate, endDate }) => {
  const ref = useRef();

  const [showDrop, setShowDrop] = useState(false);

  const closeDrop = e => {
    if (ref.current && e && ref.current.contains(e.target)) {
      return;
    }
    setShowDrop(false);
  };

  return (
    <>
      <Box
        background="transparent"
        direction="row"
        align="center"
        alignContent="center"
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          setShowDrop(!showDrop);
        }}
        gap="small"
        forwardRef={ref}
      >
        <Dates startDate={startDate} endDate={endDate} />
        <FormDown />
      </Box>

      {ref.current && showDrop && (
        <CustomDateDrop
          forwardRef={ref}
          closeDrop={closeDrop}
          dispatch={dispatch}
          startDate={startDate}
          endDate={endDate}
        />
      )}
    </>
  );
};

DatePicker.propTypes = {
  dispatch: PropTypes.func.isRequired,
  endDate: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
};

export default DatePicker;
